/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createBitcoinAddress} from '../api'

export const useMutationCreateBitcoinAddress = createReactQueryMutationHook('createBitcoinAddress', createBitcoinAddress)
